import React from "react";
import { ReactComponent as BigMoveUpIcon } from "svg/big-move-up.svg";
import { ReactComponent as BigMoveDownIcon } from "svg/big-move-down.svg";
import { ReactComponent as SmolMoveUpIcon } from "svg/smol-move-up.svg";
import { ReactComponent as SmolMoveDownIcon } from "svg/smol-move-down.svg";

const dps_list = [
  "Warlock-Affliction",
  "Warlock-Destruction",
  "Warlock-Demonology",
  "Priest-Shadow",
  "Evoker-Augmentation",
  "Evoker-Devastation",
  "Druid-Balance",
  "Hunter-BeastMastery",
  "Hunter-Marksmanship",
  "Mage-Fire",
  "Mage-Arcane",
  "Mage-Frost",
  "Shaman-Elemental",
  "Monk-Windwalker",
  "Rogue-Outlaw",
  "DemonHunter-Havoc",
  "DeathKnight-Unholy",
  "DeathKnight-Frost",
  "Paladin-Retribution",
  "Warrior-Fury",
  "Warrior-Arms",
  "Shaman-Enhancement",
  "Druid-Feral",
  "Rogue-Assassination",
  "Rogue-Subtlety",
  "Hunter-Survival",
];
const healing_list = [
  "Priest-Holy",
  "Priest-Discipline",
  "Druid-Restoration",
  "Shaman-Restoration",
  "Monk-Mistweaver",
  "Paladin-Holy",
  "Evoker-Preservation",
];
const tank_list = [
  "DeathKnight-Blood",
  "Druid-Guardian",
  "Monk-Brewmaster",
  "DemonHunter-Vengeance",
  "Warrior-Protection",
  "Paladin-Protection",
];

export const tierListColor = (tierLetter) => {
  if (tierLetter === "S") return "#ff9b00";
  else if (tierLetter === "A") return "#3273FA";
  else if (tierLetter === "B") return "#FFFFFF";
  else if (tierLetter === "C") return "#fcb1b2";
  return "#FFFFFF";
};

export const getTierArrowMovedIcon = (movedArrowValue) => {
  let arrowStyling = { float: "right", width: "20px", height: "20px" };
  switch (movedArrowValue) {
    case 1:
      return <BigMoveUpIcon style={arrowStyling} />;
    case 2:
      return <SmolMoveUpIcon style={arrowStyling} />;
    case 3:
      return <SmolMoveDownIcon style={arrowStyling} />;
    case 4:
      return <BigMoveDownIcon style={arrowStyling} />;
    default:
      return null;
  }
};

const colorByStatPriority = {
  0: {
    left: "#FF9635",
    right: "#F67314",
  },
  1: {
    left: "#C34EFF",
    right: "#B436F4",
  },
  2: {
    left: "#4770FF",
    right: "#3860EE",
  },
  3: {
    left: "#48487B",
    right: "#343461",
  },
};

export const statPrioColor = (prio) => {
  if (prio in colorByStatPriority) {
    return colorByStatPriority[prio];
  }
  return colorByStatPriority[3];
};

export const parseTierFromBuildsObject = (buildData, encounterType, encounter, classData, specData) => {
  if (buildData) {
    let tierlistLabel = "";
    switch (encounterType) {
      case "raid":
        tierlistLabel = "raid_tier_list";
        break;
      case "mythic":
        tierlistLabel = "mythic_tier_list";
        break;
      default:
        tierlistLabel = "all_tierlists";
        break;
    }

    const fullnameData = classData + "-" + specData;
    let tierlist = "tank_tier_list";
    if (dps_list.includes(fullnameData)) tierlist = "dps_list";
    else if (healing_list.includes(fullnameData)) tierlist = "healing_tier_list";
    const tierlistData = buildData[tierlistLabel]?.[encounter][tierlist];
    const specInTierList = tierlistData?.find((element) => element.class == classData && element.spec == specData);

    if (specInTierList) return specInTierList.tier_letter;
    else return 0;
  } else {
    return 0;
  }
};
